"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDiv = exports.ListPriceDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ListPriceDiv = styled_components_1.default.div `
  margin-top: ${(props) => (props.topSpacing ? props.theme.spacings.small : props.theme.spacings.mini)};
`;
exports.StyledDiv = styled_components_1.default.div `
  display: inline-block;
  margin-left: 5px;
`;
